import { DisplayRuleType, I18nTypes } from '@diagentech/exprworks-rule-engine';
import { ViolationProps } from '@diagentech/exprworks-ui-components';
import React, { ComponentType } from 'react';

import { useAppSelector } from '@/App/hooks';
import { selectDisplayRuleType } from '@/features/displayRules/selectDisplayRuleType';
import { selectFieldMaxLength } from '@/features/displayRules/selectFieldMaxLength';
import { selectViolations } from '@/features/violations/selectViolations';
import { PageFragmentProps } from '@/features/withPageFragmentInit';
import ExpEngine from '@/services/ExpEngine';

export interface WithDisplayRuleProps extends ViolationProps, PageFragmentProps {
  id: I18nTypes;
  displayRuleIndexes?: number[];
  disabled?: boolean;
  required?: boolean;
  maxLength?: number;
}

export const withDisplayRule = <P extends object>(
  Component: ComponentType<P & WithDisplayRuleProps>,
): React.FC<P & WithDisplayRuleProps> => {
  const HOC = (props: P & WithDisplayRuleProps) => {
    const { id: displayRuleId, displayRuleIndexes, screenRef, actionRef } = props;
    const id = ExpEngine.getDisplayRuleService().getDisplayRuleElementId(displayRuleId, displayRuleIndexes);
    const violations = useAppSelector(selectViolations(id));
    const displayRuleType = useAppSelector(selectDisplayRuleType(screenRef, actionRef, id));
    const maxLength = useAppSelector(selectFieldMaxLength(screenRef, actionRef, id));
    if (!displayRuleType || displayRuleType === DisplayRuleType.HIDDEN) {
      return null;
    }
    return (
      <Component
        {...props}
        displayRuleType={displayRuleType}
        {...(maxLength ? { maxLength } : {})}
        violations={violations}
      />
    );
  };
  HOC.displayName = `withDisplayRule(${Component.displayName || Component.name || 'Component'})`;
  return HOC;
};
